export const areEqual = (prevProps, nextProps) => {
  const { 
    selectedDays: prevSelectedDays,
    handlePrevWeek: prevHandlePrevWeek, 
    handleNextWeek: prevHandleNextWeek, 
  } = prevProps;

  const { 
    selectedDays: nextSelectedDays,
    handlePrevWeek: nextHandlePrevWeek, 
    handleNextWeek: nextHandleNextWeek, 
  } = nextProps;

  // Function props wrapped in useCallback equality checks
  if ((prevHandlePrevWeek !== nextHandlePrevWeek) || (prevHandleNextWeek !== nextHandleNextWeek)) {
    return false;
  }

  // startDate/endDate prop equality checks
  return (prevSelectedDays[0].getTime() === nextSelectedDays[0].getTime());
};